import { render, staticRenderFns } from "./ComprobanteTesoreriaPage.vue?vue&type=template&id=9b702e1e"
import script from "./ComprobanteTesoreriaPage.js?vue&type=script&lang=js&external"
export * from "./ComprobanteTesoreriaPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports